export default __webpack_public_path__ + "static/media/get_it_because_pipe_organ.d6146e32.mp3";